<template>
  <div class="device-detail-sheet-history">
    <!-- 过滤 -->
    <div class="query-filter">
      <div class="select-date">
        <h1>{{ $t('Common.com_date') }}</h1>
        <div class="picker-date">
          <!-- 历史报表 -->
          <!-- 年 -->
          <year-picker v-show="reportType === '1'" v-model="reportYearTime" :unbindOrgTime="deviceInfo.unbindOrgTime"></year-picker>
          <!-- 季度 -->
          <season-picker v-show="reportType === '2'" v-model="reportSeasonTime" ref="jidupicker" :unbindOrgTime="deviceInfo.unbindOrgTime"></season-picker>
          <!-- 月 -->
          <el-date-picker
            v-show="reportType === '3'"
            v-model="reportMonthTime"
            type="monthrange"
            :format="$getElFormat('yyyy-MM', true)"
            value-format="yyyy-MM"
            align="right"
            :placeholder="$t('device_detail_sheet_history_traditional.qing_xuan_ze_yue_fen')"
            :picker-options="beforeToday2016"
            :clearable="false"
            style="width: 240px"
          ></el-date-picker>
          <!--周 -->
          <week-picker v-show="reportType === '4'" v-model="reportWeekTime" :unbindOrgTime="deviceInfo.unbindOrgTime"></week-picker>
           <!-- 日 -->
            <custom-date-picker
              v-show="reportType === '5'"
              v-model="reportDayTime"
              :init-value="initValue"
              type="daterange"
              align="right"
              value-format="YYYY-MM-DD HH:mm:ss"
              :picker-options="beforeToday2016"
              :clearable="false"
              style="width: 240px"
            ></custom-date-picker>
          <el-radio-group size="medium" v-model="reportType" class="summary-type">
            <el-radio-button v-for="(item, index) in dic.dms_summary_report_type" :key="index" :label="item.value">{{ item.name }}</el-radio-button>
          </el-radio-group>
        </div>
      </div>

      <div class="tab-box" style="height: 40px">
        <el-tabs v-model="workClass" :key="3">
          <el-tab-pane v-for="item in tabData" :label="item.name" :name="item.value" :key="item.value"></el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <div class="chart-box">
      <!-- {{sheetList}} -->
      <sheet-line :lineData="sheetList" :lineType="workClass"></sheet-line>
      <div class="sheet-info">
        <ul class="box">
          <!-- 全部 -->
          <template v-if="`${workClass}` === '0'">
            <li class="item">
              <p class="mode">{{ $t('Common.com_time_cleaned') }}</p>
              <ul>
                <li class="param">
                  <p>{{ info.totalUsageTime === 0 ? '-' : $formatSecToHm(info.totalUsageTime) }}</p>
                </li>
              </ul>
            </li>
            <li class="item">
              <p class="mode">{{ $t('Common.com_area_cleaned') }}</p>
              <ul>
                <li class="param">
                  <p>{{ info.totalCleanArea === 0 ? '-' : $formatAreaToUnit($toFixed(info.totalCleanArea)) }}</p>
                </li>
              </ul>
            </li>
            <li class="item">
              <p class="mode">{{ $t('device_detail_sheet_history_traditional.qing_jie_ci_shu') }}</p>
              <ul>
                <li class="param">
                  <p>{{ info.totalUsageCount }}</p>
                </li>
              </ul>
            </li>
            <li class="item" v-if="isAutonomous">
              <p class="mode">{{ $t('device_detail_sheet_history_traditional.fu_zhu_ci_shu') }}</p>
              <ul>
                <li class="param">
                  <p>{{ info.assistCount }}</p>
                </li>
              </ul>
            </li>
            <li class="item">
              <p class="mode">{{ $t('device_detail_sheet_history_traditional.kai_ji_shi_chang') }}</p>
              <ul>
                <li class="param">
                  <p>{{ info.bootTime === 0 ? '-' : $formatSecToHm(info.bootTime) }}</p>
                </li>
              </ul>
            </li>
            <li class="item">
              <p class="mode">{{ $t('device_detail_sheet_history_traditional.kai_ji_ci_shu') }}</p>
              <ul>
                <li class="param">
                  <p>{{ info.bootCount || '-'}}</p>
                </li>
              </ul>
            </li>
          </template>
          <!-- 手工-->
          <template v-if="isManual && `${workClass}` === '2'">
            <li class="item">
              <p class="mode">{{ $t('Common.com_time_cleaned') }}</p>
              <ul>
                <li class="param">
                  <p>{{ info.manualUsageTime === 0 ? '-' : $formatSecToHm(info.manualUsageTime) }}</p>
                </li>
              </ul>
            </li>
            <li class="item">
              <p class="mode">{{ $t('Common.com_area_cleaned') }}</p>
              <ul>
                <li class="param">
                  <p>{{ info.manualCleanArea === 0 ? '-' : $formatAreaToUnit($toFixed(info.manualCleanArea)) }}</p>
                </li>
              </ul>
            </li>
          </template>
          <!-- 智能清洁-->
          <template v-if="isAutonomous && `${workClass}` === '5'">
            <li class="item">
              <p class="mode">{{ $t('Common.com_time_cleaned') }}</p>
              <ul>
                <li class="param">
                  <p>{{ info.autonomousUsageTime === 0 ? '-' : $formatSecToHm(info.autonomousUsageTime) }}</p>
                </li>
              </ul>
            </li>
            <li class="item">
              <p class="mode">{{ $t('Common.com_area_cleaned') }}</p>
              <ul>
                <li class="param">
                  <p>{{ info.autonomousCleanArea === 0 ? '-' : $formatAreaToUnit($toFixed(info.autonomousCleanArea)) }}</p>
                </li>
              </ul>
            </li>
            <li class="item">
              <p class="mode">{{ $t('device_detail_sheet_history_traditional.fu_zhu_ci_shu') }}</p>
              <ul>
                <li class="param">
                  <p>{{ info.assistCount }}</p>
                </li>
              </ul>
            </li>
          </template>
          <!-- 教学 -->
          <template v-if="isTraining && `${workClass}` === '4'">
            <li class="item">
              <p class="mode">{{ $t('Common.com_time_cleaned') }}</p>
              <ul>
                <li class="param">
                  <p>{{ info.trainingUsageTime === 0 ? '-' : $formatSecToHm(info.trainingUsageTime) }}</p>
                </li>
              </ul>
            </li>
            <li class="item">
              <p class="mode">{{ $t('Common.com_area_cleaned') }}</p>
              <ul>
                <li class="param">
                  <p>{{ info.trainingCleanArea === 0 ? '-' :$formatAreaToUnit($toFixed(info.trainingCleanArea)) }}</p>
                </li>
              </ul>
            </li>
          </template>
          <!-- 开机 -->
          <template  v-if="isBoot &&`${workClass}` === '8'">
            <li class="item">
              <p class="mode">{{ $t('device_detail_sheet_history_traditional.kai_ji_shi_chang') }}</p>
              <ul>
                <li class="param">
                  <p>{{ info.bootTime === 0 ? '-' : $formatSecToHm(info.bootTime) }}</p>
                </li>
              </ul>
            </li>
            <li class="item">
              <p class="mode">{{ $t('device_detail_sheet_history_traditional.kai_ji_ci_shu') }}</p>
              <ul>
                <li class="param">
                  <p>{{ info.bootCount || '-'}}</p>
                </li>
              </ul>
            </li>
          </template>
          <!-- 充电-->
          <!-- v-if=" `${workClass}` === '1'" -->
           <template v-if="isCharging &&`${workClass}` === '0' || `${workClass}` === '1'">
            <li class="item">
              <p class="mode">{{ $t('device_detail_sheet_history_traditional.chong_dian_shi_chang') }}</p>
              <ul>
                <li class="param">
                  <p>{{ info.chargingTime === 0 ? '-' : $formatSecToHm(info.chargingTime) }}</p>
                </li>
              </ul>
            </li>
          </template>
        </ul>
      </div>
    </div>
    <div class="table-list">
      <!-- {{tableList}} -->
      <div class="header">
        <div class="label">{{ $t('device_detail_sheet_history_traditional.shu_ju_xiang_qing') }}</div>
        <div class="search-content">
          <el-form :inline="true" @submit.native.prevent>
            <el-form-item style="float: right; margin-right: 0">
              <custom-column ref="column"></custom-column>
            </el-form-item>
            <el-form-item style="float: right" v-if="funcView.device_detail_annual_export">
              <el-button class="custom-btn" icon="icon icon-export-excel left-icon" type="info" round @click="exportHistory">{{ $t('Common.com_export') }}</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="table-bd">
        <custom-table
          v-if="isUs"
          :data="tableList"
          tableCode="portal_device_sheet_history_ft"
          height="100%"
          :filterArr="filterArr"
          @filter="filterChange"
          :slots="['manualCleanArea', 'autonomousCleanArea', 'trainingCleanArea']"
          @sort="sortChange"
          @column="setColumn"
        >
        <!--
          manualCleanArea
          autonomousCleanArea
          trainingCleanArea
        -->
          <template v-slot:manualCleanArea="scope">
            <span>{{$formatLenLocal(scope.row.manualCleanArea)}}</span>
          </template>
          <template v-slot:autonomousCleanArea="scope">
            <span>{{$formatLenLocal(scope.row.autonomousCleanArea)}}</span>
          </template>
          <template v-slot:trainingCleanArea="scope">
            <span>{{$formatLenLocal(scope.row.trainingCleanArea)}}</span>
          </template>
        </custom-table>

        <custom-table
          v-else
          :data="tableList"
          tableCode="portal_device_sheet_history"
          height="100%"
          :filterArr="filterArr"
          @filter="filterChange"
          @sort="sortChange"
          @column="setColumn"
        ></custom-table>
      </div>
      <div class="table-footer">
        <custom-pagination radius :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import seasonPicker from '@/components/quarterlyRangePicker.vue';
import yearPicker from '@/components/yearRangePicker.vue';
import weekPicker from '@/components/weekRangePicker.vue';

import apis from '@/utils/apis';
import sheetLine from './line.vue';

export default {
  name: 'sheetHistoryTraditional',
  props: {
    deviceInfo: {
      type: Object,
      default: () => ({})
    },
    tabData: {
      type: Array,
      default: () => []
    },
    isCharging: {
      type: Boolean,
      default: false
    },
    isManual: {
      type: Boolean,
      default: false
    },
    isAutonomous: {
      type: Boolean,
      default: false
    },
    isTraining: {
      type: Boolean,
      default: false
    },
    isBoot: {
      type: Boolean,
      default: false
    },
    productClass: {
      type: [String, Number],
      default: ''
    }
  },
  components: {
    // ScrollBar,
    sheetLine,
    seasonPicker,
    yearPicker,
    weekPicker
  },
  computed: {
    // reportYearTime() {
    //   if (this.deviceInfo.unbindOrgTime) {
    //     return [`${moment(this.deviceInfo.unbindOrgTim)
    //       .add(-11, 'y')
    //       .year()}`,
    //     `${moment(this.deviceInfo.unbindOrgTim).year()}`
    //     ];
    //   }
    //   return [`${moment(this.deviceInfo.unbindOrgTim)
    //     .add(-11, 'y')
    //     .year()}`,
    //   `${moment(this.deviceInfo.unbindOrgTim).year()}`
    //   ];
    // },
    // reportSeasonTime() {
    //   if (this.deviceInfo.unbindOrgTime) {
    //     return [
    //       moment(this.deviceInfo.unbindOrgTime).toDate().getMonth() < 10 ? `${moment(this.deviceInfo.unbindOrgTime).toDate().getFullYear() - 3}-${this.getSeason(moment(this.deviceInfo.unbindOrgTime).toDate().getMonth() + 3)}`
    //         : `${moment(this.deviceInfo.unbindOrgTime).toDate().getFullYear() - 2}-01`,
    //       `${moment(this.deviceInfo.unbindOrgTime).toDate().getFullYear()}-${this.getSeason(moment(this.deviceInfo.unbindOrgTime).toDate().getMonth())}`
    //     ];
    //   }
    //   return [
    //     new Date().getMonth() < 10 ? `${new Date().getFullYear() - 3}-${this.getSeason(new Date().getMonth() + 3)}` : `${new Date().getFullYear() - 2}-01`,
    //     `${new Date().getFullYear()}-${this.getSeason(new Date().getMonth())}`
    //   ];
    // },
    // reportMonthTime() {
    //   if (this.deviceInfo.unbindOrgTime) {
    //     return [
    //       `${moment(this.deviceInfo.unbindOrgTime)
    //         .add(-11, 'month')
    //         .format('YYYY-MM')}`,
    //       `${moment(this.deviceInfo.unbindOrgTime)
    //         .add('month')
    //         .format('YYYY-MM')}`
    //     ];
    //   }
    //   return [
    //     `${moment()
    //       .add(-11, 'month')
    //       .format('YYYY-MM')}`,
    //     `${moment()
    //       .add('month')
    //       .format('YYYY-MM')}`
    //   ];
    // },
    // reportWeekTime() {
    //   if (this.deviceInfo.unbindOrgTime) {
    //     return [
    //       `${moment(this.deviceInfo.unbindOrgTime)
    //         .week(moment().week() - 11)
    //         .endOf('week')}`,
    //       `${moment(this.deviceInfo.unbindOrgTime)
    //         .week(moment().week())
    //         .endOf('week')}`
    //     ];
    //   }
    //   return [
    //     moment()
    //       .week(moment().week() - 11)
    //       .endOf('week'),
    //     moment()
    //       .week(moment().week())
    //       .endOf('week')
    //   ];
    // }

  },
  data() {
    return {
      selectDate: '',
      reportType: '3',
      useType: '',
      workClass: '0',
      formSearch: {
        pageNum: 1,
        pageSize: 50,
        reportType: this.reportType,
        deviceId: this.deviceInfo.deviceId,
        bodyNum: this.deviceInfo.bodyNum,
        isSum: 1
      },
      totalRows: null,
      reportDate: this.reportYearTime,
      info: {
        // 总
        totalCleanArea: '', // 总清洁面积
        totalUsageCount: '', // 总清洁次数
        totalUsageTime: '', // 总清洁时长
        // 手工
        manualUsageTime: '',
        manualCleanArea: '',
        // 智能
        autonomousUsageTime: '',
        autonomousCleanArea: '',
        // 教学
        trainingCleanArea: '',
        trainingUsageTime: '',
        assistCount: '',
        // 充电
        chargingTime: '',
        bootTime: '', // 开机时长 h:m,
        bootCount: '', // 开机次数,
      },
      sheetList: [],
      tableList: [],
      supportMode: '',
      modeTypeList: [],
      filterArr: [],
      iot_tsl_use_type2: {},

      // 历史报表
      reportYearTime: [
        `${moment(this.$getLocalTime())
          .add(-11, 'y')
          .year()}`,
        `${moment(this.$getLocalTime()).year()}`
      ],
      reportSeasonTime: [
        new Date().getMonth() < 10 ? `${new Date().getFullYear() - 2}-${this.getSeason(new Date().getMonth() - 9)}` : `${new Date().getFullYear() - 2}-01`,
        `${new Date().getFullYear()}-${this.getSeason(new Date().getMonth())}`
      ],
      reportMonthTime: [
        `${moment(this.$getLocalTime())
          .add(-11, 'month')
          .format('YYYY-MM')}`,
        `${moment(this.$getLocalTime())
          .add('month')
          .format('YYYY-MM')}`
      ],
      // 周是日期类型 用的时候需要moment转YYYY-MM-DD
      reportWeekTime: [
        this.$momentElLocal(moment()
          .week(moment().week() - 11)),
        this.$momentElLocal(moment()
          .week(moment().week()))
      ],
      initValue: [moment(this.$getLocalTime()).subtract(30, 'days').startOf('day').format('YYYY-MM-DD 00:00:00'), moment(this.$getLocalTime()).endOf('day').format('YYYY-MM-DD 23:59:59')],
      reportDayTime: '',
      pickerOptionsYear: {
        disabledDate: time => time.getFullYear() > new Date().getFullYear() // 注意是 || 不是 && 哦
      },
      beforeToday: {},
    };
  },
  watch: {
    'deviceInfo.unbindOrgTime': {
      immediate: true,
      handler(val) {
        if (val) {
          const beforeTime = this.deviceInfo.unbindOrgTime ? this.deviceInfo.unbindOrgTime : Date.now();
          this.beforeToday = {
            firstDayOfWeek: 1,
            disabledDate: time => moment(time).isAfter(beforeTime, 'day')
          };
          this.setDate();
        }
      },
    },
    reportType(val) {
      this.formSearch.reportType = val;
      // 重置分页
      this.formSearch.pageNum = 1;
      this.getReport(val);
    },
    reportYearTime() {
      // 重置分页
      this.formSearch.pageNum = 1;
      this.getReport(this.reportType);
    },
    reportSeasonTime() {
      // 重置分页
      this.formSearch.pageNum = 1;
      this.getReport(this.reportType);
    },
    reportMonthTime() {
      // 重置分页
      this.formSearch.pageNum = 1;
      this.getReport(this.reportType);
    },
    reportWeekTime() {
      // 重置分页
      this.formSearch.pageNum = 1;
      this.getReport(this.reportType);
    },
    reportDayTime() {
      // 重置分页
      this.formSearch.pageNum = 1;
      this.getReport(this.reportType);
    }
  },
  created() {},
  mounted() {
    this.getDictionary('iot_tsl_use_type2,dms_summary_report_type', (data) => {
      this.iot_tsl_use_type2 = data.iot_tsl_use_type2;
    });
    this.getFuncView('/other/device');
    this.setModeTypeList();
    this.getReport(this.reportType);
  },
  methods: {
    // 获取季度
    getSeason: function (month) {
      if (month < 3) {
        return '01';
      } else if (month < 6) {
        return '02';
      } else if (month < 9) {
        return '03';
      } else if (month < 12) {
        return '04';
      }
      return true;
    },
    // 设置时间
    setDate() {
      if (this.deviceInfo.unbindOrgTime) {
        this.reportYearTime = [`${moment(this.deviceInfo.unbindOrgTime)
          .add(-11, 'y')
          .year()}`,
        `${moment(this.deviceInfo.unbindOrgTime).year()}`
        ];
        this.reportSeasonTime = [
          moment(this.deviceInfo.unbindOrgTime).toDate().getMonth() < 10 ? `${moment(this.deviceInfo.unbindOrgTime).toDate().getFullYear() - 2}-${this.getSeason(moment(this.deviceInfo.unbindOrgTime).toDate().getMonth() - 9)}`
            : `${moment(this.deviceInfo.unbindOrgTime).toDate().getFullYear() - 2}-01`,
          `${moment(this.deviceInfo.unbindOrgTime).toDate().getFullYear()}-${this.getSeason(moment(this.deviceInfo.unbindOrgTime).toDate().getMonth())}`
        ];
        this.reportMonthTime = [
          `${moment(this.deviceInfo.unbindOrgTime)
            .add(-11, 'month')
            .format('YYYY-MM')}`,
          `${moment(this.deviceInfo.unbindOrgTime)
            .add('month')
            .format('YYYY-MM')}`
        ];
        this.reportWeekTime = [
          `${moment(this.deviceInfo.unbindOrgTime)
            .add(-11, 'week')
            .endOf('week')}`,
          `${moment(this.deviceInfo.unbindOrgTime)
            .endOf('week')}`
        ];
        this.initValue = [moment(this.deviceInfo.unbindOrgTime).startOf('month').format('YYYY-MM-DD 00:00:00'), moment(this.deviceInfo.unbindOrgTime).endOf('day').format('YYYY-MM-DD 23:59:59')];
      } else {
        this.reportYearTime = [`${moment()
          .add(-11, 'y')
          .year()}`,
        `${moment().year()}`
        ];
        this.reportSeasonTime = [
          new Date().getMonth() < 10 ? `${new Date().getFullYear() - 2}-${this.getSeason(new Date().getMonth() - 9)}` : `${new Date().getFullYear() - 2}-01`,
          `${new Date().getFullYear()}-${this.getSeason(new Date().getMonth())}`
        ];

        this.reportMonthTime = [
          `${moment()
            .add(-11, 'month')
            .format('YYYY-MM')}`,
          `${moment()
            .add('month')
            .format('YYYY-MM')}`
        ];
        this.reportWeekTime = [
          moment()
            .add(-11, 'week')
            .endOf('week'),
          moment()
            .endOf('week')
        ];
        this.initValue = [moment(this.$getLocalTime()).startOf('month').format('YYYY-MM-DD 00:00:00'), moment(this.$getLocalTime()).endOf('day').format('YYYY-MM-DD 23:59:59')];
      }


    },
    // 设置模式(过滤字段)
    setModeTypeList() {
      // const list = [];
      // 充电
      if (!this.isCharging) {
        this.filterArr.push('chargingTimeFormat');
      }
      // 手工
      if (!this.isManual) {
        this.filterArr.push('manualUsageTimeFormat', 'manualCleanArea');
      }
      // 智能
      if (!this.isAutonomous) {
        this.filterArr.push('autonomousUsageTimeFormat', 'autonomousCleanArea', 'assistCount');
      }
      // 教学
      if (!this.isTraining) {
        this.filterArr.push('trainingUsageTimeFormat', 'trainingCleanArea');
      }
      // 教学
      if (!this.isBoot) {
        this.filterArr.push('bootTimeFormat', 'bootCount');
      }
    },
    getReport: function (reportType) {
      // 年1 季2 月3 周4 日5
      if (reportType === '1') {
        this.reportDate = this.reportYearTime;
        this.formSearch.beginTime = this.reportYearTime[0];
        this.formSearch.endTime = this.reportYearTime[1];
        // 年报表
        // 图表
        this.getReportlist();
        // table
        this.getReportPage();
        // info
        this.getInfo();
      } else if (reportType === '2') {
        this.reportDate = this.reportSeasonTime;
        this.formSearch.beginTime = this.reportSeasonTime[0];
        this.formSearch.endTime = this.reportSeasonTime[1];
        // 月报表
        // 图表
        this.getReportlist();
        // table
        this.getReportPage();
        // info
        this.getInfo();
      } else if (reportType === '3') {
        this.reportDate = this.reportMonthTime;
        this.formSearch.reportType = this.reportType;
        this.formSearch.beginTime = this.reportMonthTime[0];
        this.formSearch.endTime = this.reportMonthTime[1];
        // 月报表
        // 图表
        this.getReportlist();
        // table
        this.getReportPage();
        // info
        this.getInfo();
      } else if (reportType === '4') {
        this.reportDate = this.reportWeekTime;
        // this.formSearch.reportDate = moment(
        //   new Date(this.reportWeekTime)
        // ).format('gggg-ww'); // 转换时间因为现在是Date类型

        // moment.localeData().firstDayOfWeek(6);
        // 设置周的开始时间是星期一 1月1号是年开始的第一周
        moment.updateLocale('en', { week: {
          // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
          dow: 1, // Monday is the first day of the week.
          doy: 7 // The week that contains Jan 4th is the first week of the year.// 年份的第一周必须包含1月1日 (7 + 1 - 1)
        } });
        this.formSearch.beginTime = moment(this.reportWeekTime[0]).endOf('week').format('gggg-ww'); // 转换时间因为现在是Date类型
        this.formSearch.endTime = moment(this.reportWeekTime[1]).endOf('week').format('gggg-ww'); // 转换时间因为现在是Date类型

        // 月报表
        // 图表
        this.getReportlist();
        // table
        this.getReportPage();
        // info
        this.getInfo();
      } else if (reportType === '5') {
        this.reportDate = this.reportDayTime;
        this.formSearch.reportType = this.reportType;
        this.formSearch.beginTime = this.reportDayTime[0];
        this.formSearch.endTime = this.reportDayTime[1];
        // 月报表
        // 图表
        this.getReportDaylist();
        // table
        this.getReportDayPage();
        // info
        this.getDayInfo();
      }
    },
    // 月报表 周 图表
    getReportlist: function () {
      this.$getJSON(apis.deviceReportSummaryList, this.formSearch).then((res) => {
        // this.sheetList = res.data || [];
        const list = res.data || [];
        list.forEach((item) => {
          const digit = 2;
          // 清洁时间 format
          const totalUsageTime = item.totalUsageTime / 60;
          item.totalUsageTime = Math.round(Number.parseFloat(`${totalUsageTime}`) * 10 ** digit) / 10 ** digit;
          const manualUsageTime = item.manualUsageTime / 60;
          item.manualUsageTime = Math.round(Number.parseFloat(`${manualUsageTime}`) * 10 ** digit) / 10 ** digit;
          const autonomousUsageTime = item.autonomousUsageTime / 60;
          item.autonomousUsageTime = Math.round(Number.parseFloat(`${autonomousUsageTime}`) * 10 ** digit) / 10 ** digit;
          const trainingUsageTime = item.trainingUsageTime / 60;
          item.trainingUsageTime = Math.round(Number.parseFloat(`${trainingUsageTime}`) * 10 ** digit) / 10 ** digit;
          const chargingTime = item.chargingTime / 60;
          item.chargingTime = Math.round(Number.parseFloat(`${chargingTime}`) * 10 ** digit) / 10 ** digit;
          const bootTime = item.bootTime / 60;
          item.bootTime = Math.round(Number.parseFloat(`${bootTime}`) * 10 ** digit) / 10 ** digit;

          item.totalCleanArea = this.$formatLenLocal(item.totalCleanArea);
          item.manualCleanArea = this.$formatLenLocal(item.manualCleanArea);
          item.autonomousCleanArea = this.$formatLenLocal(item.autonomousCleanArea);
          item.trainingCleanArea = this.$formatLenLocal(item.trainingCleanArea);
        });
        this.sheetList = list;
      }).catch(() => {
        this.sheetList = [];
      });
    },
    // 月 周 table
    getReportPage: function () {
      this.$getJSON(apis.deviceReportSummaryPage, this.formSearch).then((res) => {
        const data = res.data.list || [];
        this.nullValueToCrossbar(data, ['assistCount']);
        this.tableList = data;
        this.totalRows = res.data.total;
      }).catch(() => {
        this.tableList = [];
        this.totalRows = null;
      });
    },
    // 年报表 季度 月 周 info
    getInfo: function () {
      this.$getJSON(apis.deviceReportSummaryCount, {
        ...this.formSearch,
        deviceId: this.deviceInfo.deviceId
      }).then((res) => {
        if (res.data && Object.keys(res.data).length !== 0) {
          this.$setFormatData(this.info, res.data);
        } else {
          // 总
          this.info.totalCleanArea = 0;
          this.info.totalUsageCount = 0;
          this.info.totalUsageTime = 0;
          // 手工
          this.info.manualUsageTime = 0;
          this.info.manualCleanArea = 0;
          // 智能
          this.info.autonomousUsageTime = 0;
          this.info.autonomousCleanArea = 0;
          // 智能

          this.info.trainingUsageTime = 0;
          this.info.trainingCleanArea = 0;
          this.info.assistCount = 0;
          // 充电
          this.info.chargingTime = 0;
          this.info.bootTime = 0; // 开机时长 h:m,
          this.info.bootCount = 0; // 开机次数,
        }
      }).catch(() => {
        // 总
        this.info.totalCleanArea = 0;
        this.info.totalUsageCount = 0;
        this.info.totalUsageTime = 0;
        // 手工
        this.info.manualUsageTime = 0;
        this.info.manualCleanArea = 0;
        // 智能
        this.info.autonomousUsageTime = 0;
        this.info.autonomousCleanArea = 0;
        // 智能

        this.info.trainingUsageTime = 0;
        this.info.trainingCleanArea = 0;
        this.info.assistCount = 0;
        // 充电
        this.info.chargingTime = 0;
        this.info.bootTime = 0; // 开机时长 h:m,
        this.info.bootCount = 0; // 开机次数,
      });
    },
    getReportDaylist: function () {
      this.$getJSON(apis.portalDeviceReportDailyList, { ...this.formSearch,
        // 字段改了要用startDate endDate传时间 天的格式
        startDate: this.$momentElLocal(this.formSearch.beginTime, 'YYYY-MM-DD'),
        endDate: this.$momentElLocal(this.formSearch.endTime, 'YYYY-MM-DD')
      }).then((res) => {
        // this.sheetList = res.data || [];
        const list = res.data || [];
        list.forEach((item) => {
          const digit = 2;
          // 清洁时间 format
          const totalUsageTime = item.totalUsageTime / 60;
          item.totalUsageTime = Math.round(Number.parseFloat(`${totalUsageTime}`) * 10 ** digit) / 10 ** digit;
          const manualUsageTime = item.manualUsageTime / 60;
          item.manualUsageTime = Math.round(Number.parseFloat(`${manualUsageTime}`) * 10 ** digit) / 10 ** digit;
          const autonomousUsageTime = item.autonomousUsageTime / 60;
          item.autonomousUsageTime = Math.round(Number.parseFloat(`${autonomousUsageTime}`) * 10 ** digit) / 10 ** digit;
          const trainingUsageTime = item.trainingUsageTime / 60;
          item.trainingUsageTime = Math.round(Number.parseFloat(`${trainingUsageTime}`) * 10 ** digit) / 10 ** digit;
          const chargingTime = item.chargingTime / 60;
          item.chargingTime = Math.round(Number.parseFloat(`${chargingTime}`) * 10 ** digit) / 10 ** digit;
          const bootTime = item.bootTime / 60;
          item.bootTime = Math.round(Number.parseFloat(`${bootTime}`) * 10 ** digit) / 10 ** digit;

          item.totalCleanArea = this.$formatLenLocal(item.totalCleanArea);
          item.manualCleanArea = this.$formatLenLocal(item.manualCleanArea);
          item.autonomousCleanArea = this.$formatLenLocal(item.autonomousCleanArea);
          item.trainingCleanArea = this.$formatLenLocal(item.trainingCleanArea);
        });
        this.sheetList = list;
      }).catch(() => {
        this.sheetList = [];
      });
    },
    // 月 周 table
    getReportDayPage: function () {
      this.$getJSON(apis.portalDeviceReportDailyPage, { ...this.formSearch,
        // 字段改了要用startDate endDate传时间 天的格式
        startDate: this.$momentElLocal(this.formSearch.beginTime, 'YYYY-MM-DD'),
        endDate: this.$momentElLocal(this.formSearch.endTime, 'YYYY-MM-DD')
      }).then((res) => {
        const data = res.data.list || [];
        this.nullValueToCrossbar(data, ['assistCount']);
        this.tableList = data;
        this.totalRows = res.data.total;
      }).catch(() => {
        this.tableList = [];
        this.totalRows = null;
      });
    },
    // 日 info
    getDayInfo: function () {
      this.$getJSON(apis.DeviceReportDaily, {
        ...this.formSearch,
        deviceId: this.deviceInfo.deviceId,
        bodyNum: this.deviceInfo.bodyNum,
        startDate: this.$momentElLocal(this.formSearch.beginTime, 'YYYY-MM-DD'),
        endDate: this.$momentElLocal(this.formSearch.endTime, 'YYYY-MM-DD')
      }).then((res) => {
        if (res.data && Object.keys(res.data).length !== 0) {
          this.$setFormatData(this.info, res.data);
        } else {
          // 总
          this.info.totalCleanArea = 0;
          this.info.totalUsageCount = 0;
          this.info.totalUsageTime = 0;
          // 手工
          this.info.manualUsageTime = 0;
          this.info.manualCleanArea = 0;
          // 智能
          this.info.autonomousUsageTime = 0;
          this.info.autonomousCleanArea = 0;
          // 智能

          this.info.trainingUsageTime = 0;
          this.info.trainingCleanArea = 0;
          this.info.assistCount = 0;
          // 充电
          this.info.chargingTime = 0;
        }
      }).catch(() => {
        // 总
        this.info.totalCleanArea = 0;
        this.info.totalUsageCount = 0;
        this.info.totalUsageTime = 0;
        // 手工
        this.info.manualUsageTime = 0;
        this.info.manualCleanArea = 0;
        // 智能
        this.info.autonomousUsageTime = 0;
        this.info.autonomousCleanArea = 0;
        // 智能

        this.info.trainingUsageTime = 0;
        this.info.trainingCleanArea = 0;
        this.info.assistCount = 0;
        // 充电
        this.info.chargingTime = 0;
      });
    },
    // 导出数据
    exportHistory: function () {
      if (this.reportType === '5') {
        this.$exportFlie(apis.portalDeviceReportDailyExport, {
          ...this.formSearch,
          startDate: this.$momentElLocal(this.formSearch.beginTime, 'YYYY-MM-DD'),
          endDate: this.$momentElLocal(this.formSearch.endTime, 'YYYY-MM-DD'),
          reportType: this.reportType,
          deviceId: this.deviceInfo.deviceId,
          platform: 'portal',
          excludeColumnList: [...this.filterArr, 'locationName', 'siteName', 'orgName']
        }).then(() => {});
      } else {
        this.$exportFlie(apis.deviceReportHistoryExport, {
          ...this.formSearch,
          reportType: this.reportType,
          deviceId: this.deviceInfo.deviceId,
          platform: 'portal',
          excludeColumnList: [...this.filterArr, 'locationName', 'siteName', 'orgName']
        }).then(() => {});
      }

    },

    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      if (this.reportType === '5') {
        this.getReportDayPage();
      } else {
        this.getReportPage();
      }

    }
  }
};
</script>

<style lang="scss">
@import '@/style/colors.scss';
.device-detail-sheet-history {
  .select-date {
    h1 {
      font-size: 12px;
      line-height: 17px;
      font-weight: bold;
      color: $--color-primary;
      margin-bottom: 4px;
    }
    .picker-date {
      height: 60px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .el-date-editor {
        transform: translateX(-8px);
      }
      input {
        font-weight: bold;
      }
      .el-range__close-icon.el-input__icon:after {
        font-family: 'icon' !important;
        content: '\E7F8';
        font-size: 22px;
        line-height: 42px;
        margin-right: 30px;
        color: $--color-warning;
      }
      .el-input__icon.el-range__icon.el-icon-date {
        color: $--color-primary;
        font-size: 18px;
        margin-top: 2px;
      }
      .el-input .el-input__inner {
        cursor: pointer;
        height: 40px;
        line-height: 41px;
        padding-left: 34px;
        font-weight: bold;
        color: $--color-text-primary;
      }

      .summary-type {
        .el-radio-button {
          height: 40px;
          .el-radio-button__inner {
            height: 40px;
            line-height: 40px;
            padding: 0 20px;
          }
          &:first-child .el-radio-button__inner {
            border-radius: 100px 0px 0px 100px;
          }
          &:last-child .el-radio-button__inner {
            border-radius: 0px 100px 100px 0px;
          }
        }
      }
    }
  }
  .el-tabs .el-tabs__item {
    font-size: 14px;
  }
  .chart-box {
    background: #ffffff;
    border-radius: 16px;
    margin-top: 24px;
    padding: 24px;

    .chart {
      // padding: 0 24px;
      background-color: #fff;
      padding-top: 10px;
      position: relative;
      .legend {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        ul {
          display: flex;
          li {
            height: 17px;
            font-size: 12px;
            color: rgba(108, 117, 125, 1);
            line-height: 17px;
            margin-right: 20px;
            i {
              display: inline-block;
              width: 10px;
              height: 10px;
              margin-right: 3px;
            }
            .line {
              height: 3px;
              background-color: #5ad8a6;
            }

            .interval-bule {
              background-color: #6dc2ed;
            }
            .interval-black {
              background-color: #253048;
            }
          }
        }
      }
    }

    .sheet-info {
      padding: 24px 24px 24px 0;
      .box {
        padding: 0 16px;
        display: flex;
        li.item {
          border-right: 1px solid #e9ebec;
          margin-left: 32px;
          width: 150px;
          &:first-child {
            margin: 0;
          }
          .mode {
            font-size: 12px;
            font-weight: bold;
            color: $--color-text-secondary;
            line-height: 17px;
          }
          ul {
            display: flex;
            margin-top: 4px;
            .param {
              padding-right: 32px;
              // h2 {
              //   height: 17px;
              //   font-size: 12px;
              //   color: rgba(152, 166, 173, 1);
              //   line-height: 17px;
              //   margin-bottom: 5px;
              // }
              p {
                height: 25px;
                font-size: 18px;
                font-weight: bold;
                color: $--color-text-primary;
                line-height: 25px;
              }
            }
          }

          &:last-of-type {
            border: none;
          }
        }
      }
      .time {
        color: #0d9ae0;
      }
      .box-bottom {
        margin-top: 16px;
        text-align: right;
        height: 17px;
        font-size: 12px;
        color: #6c757d;
        line-height: 17px;
      }
    }
  }

  .table-list {
    background: #ffffff;
    border-radius: 16px;
    padding: 24px 24px 0;
    margin-top: 24px;

    .header {
      // padding: 24px;
      .label {
        color: #1a1a1a;
        line-height: 40px;
        font-weight: bold;
        float: left;
      }
      .search-content {
        float: right;
      }
    }
    .title {
      height: 40px;
      font-size: 18px;
      font-weight: bold;
      color: #1a1a1a;
      line-height: 40px;
      display: flex;
      justify-content: space-between;
    }
    .table-bd {
      margin-top: 24px;
      height: 444px;
      width: 100%;
      overflow: hidden;
    }
  }
}
</style>
